import { useEffect, useRef } from "react";

/** ALTCHA injects a focusable logo link inside aria-hidden UI when auto="onsubmit". */
function patchAltchaFocus(root) {
	if (!root) return;

	root.querySelectorAll("a.altcha-logo").forEach((link) => {
		link.setAttribute("tabindex", "-1");
	});

	root.querySelectorAll('[aria-hidden="true"]').forEach((hidden) => {
		hidden.querySelectorAll("a[href], button, input, select, textarea").forEach((el) => {
			el.setAttribute("tabindex", "-1");
		});
	});
}

export default function AltchaCaptcha() {
	const hostRef = useRef(null);

	useEffect(() => {
		const root = hostRef.current;
		if (!root) return;

		patchAltchaFocus(root);
		const observer = new MutationObserver(() => patchAltchaFocus(root));
		observer.observe(root, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["aria-hidden"],
		});

		return () => observer.disconnect();
	}, []);

	return (
		<div ref={hostRef} className="tu-altcha">
			<altcha-widget
				challengeurl="/api/altcha"
				auto="onsubmit"
				hidelogo
				hidefooter
			/>
		</div>
	);
}
